/**
 * Class responsible for masking PIX Keys.
 * 
 * @class MaskUtils
 * @example
 * const maskedKey = MaskUtils.maskText("18999999999", "phoneNumber");
 * console.log(maskedKey); // (18) 99999-9999
 */
class MaskUtils {
  //  ****************
  //  ** Properties **
  //  ****************
  static masks = {
    phoneNumber: {
      version1: "(00) 00000-0000",
      version2: "(00) 0000-0000",
    }
    , cpf: "000.000.000-00"
    , cnpj: "00.000.000/0000-00"
  };



  //  *************
  //  ** Methods **
  //  *************

  /**
   * 
   * @param {string} text - The text to be masked.
   * @param {string} maskType - The type of mask to be applied: "phoneNumber" | "cpf" | "cnpj".
   * @returns {string} The masked text if the provided maskType is valid, otherwise the raw text is returned.
   */
  static maskText(text, maskType) {
    let mask;
    if (maskType !== "phoneNumber") mask = this.masks[maskType];
    else if (text.length === 11) mask = this.masks[maskType].version1;
    else mask = this.masks[maskType].version2;

    if (!mask) return text;

    const wildcard = "0";
    let characterTextIndex = 0;

    return [...mask].reduce((accumulator, maskCharacter) => {
      if (maskCharacter === wildcard && characterTextIndex < text.length) {
        accumulator += text[characterTextIndex++];
      }
      else if (maskCharacter !== wildcard && characterTextIndex < text.length) {
        accumulator += maskCharacter;
      }

      return accumulator;
    }, "");
  }
}

export default MaskUtils;
